import CodeMirror from 'codemirror/src/codemirror.js'
window.CodeMirror = CodeMirror
